const styles = `
    &.dn-private {
        background-color: #FFFFFF;
        background-image:
            linear-gradient(to right, rgba(15, 23, 42, 0.005) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(15, 23, 42, 0.005) 1px, transparent 1px);
        background-size: 4px 4px;
    }
`;

export default styles;
